import React, { forwardRef } from 'react';
import { Icons } from '../icons/icons';
import { ErrorMessage } from './error';

type Option = {
  value: string;
  label: string;
};

type Props = {
  name: string;
  value?: string;
  options?: Option[];
  label?: string;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

const SelectBox = (className: string) => (props: Props): JSX.Element => {
  return (
    <div className={props.className}>
      {props.label ? <label htmlFor={props.name} className="form-label">
        {props.label}
      </label> : null}
      <div className="position-relative bg-white">
        <select className={`form-control bg-transparent position-relative ${className}`} onChange={props.onChange} value={props.value}>
          {props.options?.map((item, index) => {
            return (
              <option key={index} value={item.value}>
                {item.label}
              </option>
            );
          })}
        </select>
        <Icons.ArrowDown className="select-arrow" width={className === 'select-sm' ? '18' : undefined} />
      </div>
    </div>
  );
};

export const Select = SelectBox('select-lg');
export const SelectSmall = SelectBox('select-sm');

type Select2Props = {
  name: string;
  children: any;
  errors?: any;
};

const SelectBox2 = (className: string): any => forwardRef((props: Select2Props, ref: any): JSX.Element => {
  const { errors, ...otherProps } = props;
  const errorClassName = errors?.[otherProps.name] ? 'invalid' : '';
  const mergedProps = { ...otherProps, className: `form-control bg-transparent position-relative ${className} ${errorClassName}` };
  return <>
    <div className="position-relative bg-white">
      <select {...mergedProps} ref={ref}>{otherProps.children}</select>
      <Icons.ArrowDown className="select-arrow" width={className === 'select-sm' ? '18' : undefined} />
    </div>
    {errors?.[otherProps.name]?.message && <ErrorMessage>{errors[otherProps.name].message}</ErrorMessage>}
  </>;
});

export const Select2 = SelectBox2('select-lg');
